import { TypeOf } from '../../../index'

export class ProviderHelper<P> {

  constructor(private _providerClass: TypeOf<P>, private _providerInstance: P) {}

  public withEnsuredDIDependencies(
    expectedParamTypes: Array<TypeOf<any>>,
    decoratedFn: (...args: any[]) => any
  ) {
    return (...args: any[]) => {
      const normalizedArgs = args || []
      expectedParamTypes.forEach((paramType, i) => {
        if (normalizedArgs[i] !== undefined) { return }
        throw new Error(this._generateArgumentUndefinedMessage(paramType, decoratedFn))
      })
      return decoratedFn.call(this._providerInstance, ...args)
    }
  }

  private _determineCallerName(): string {
    let className
    [this._providerClass, this._providerInstance].some((something) => {
      className = this._determineClassName(something)
      return !!className
    })
    return className || '(cannot determine provider class name)'
  }

  private _determineClassName(anything: any): string {
    const anythingType = typeof anything
    switch (anythingType) {
      case 'function': return anything.name
      case 'object': return anything.constructor ? anything.constructor.name : undefined
      case 'string': return anything
      default: return undefined
    }
  }

  private _determineFunctionName(fn: (...args: any[]) => any) {
    let name = fn.name
    if (name === undefined || name === '') {
      name = Object.keys(this._providerClass.prototype).find((key) => this._providerInstance[key] === fn)
    }
    return name || '(unknown function)'
  }

  private _generateArgumentUndefinedMessage(
    expectedType: TypeOf <any>,
    usingFn: (...args: any[]) => any
  ): string {
    const providerClassName = this._determineCallerName()
    const functionName = this._determineFunctionName(usingFn)
    return `Argument of type '${expectedType.name}' used in '${functionName}' is not provided!\n`
      + `Provide '${expectedType.name}' to Angular dependency injection when using ${providerClassName}.\n`
      + `For example:\n`
      + `  { provide: ${expectedType.name}, useValue: new ${expectedType.name}() }\n`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/providers/provider-helper/provider-helper.ts